// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__2aKvT","Spinner":"Hero_Spinner__5VVVs","SpinnerInner":"Hero_SpinnerInner__iMIXT"};